import { Col, Row } from "antd";
import React from "react";
import PrimaryButton from "../../../../biblio/Buttons/PrimaryButton";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../../../../apis/store";
import { addProcuration } from "../../../../apis/actions/services.actions";
import { showNotitfication } from "../../../../components/utils/utils";
import { toGetServicesListRequests } from "../../../../apis/actions/services.actions";
import parse from "html-react-parser";

interface Props {
  authorization: any;
  setIsModalVisible: React.Dispatch<React.SetStateAction<boolean>>;
}

const AddProsecutionRequest = ({ authorization, setIsModalVisible }: Props) => {
  const dispatch = useDispatch<AppDispatch>();
  const onFinish = async () => {
    try {
      const procurationData = {
        application_id: authorization.id,
        authorization_type_id: authorization.authorization_type_id,
      };

      dispatch(addProcuration(procurationData)).then((result: any) => {
        const response = result?.payload?.data?.result;
        if (response?.code === 200) {
          showNotitfication(response?.message, "success");
          setIsModalVisible(false);
          try {
            dispatch(toGetServicesListRequests({ limit: 8, page: 1 }));
          } catch (error) {
            console.error(error);
          }
        } else {
          showNotitfication(response?.message, "error");
        }
      });
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <>
      <Row justify={"center"}>
        <p className="takaful--confirm-logout">إنشاء توكيل </p>
      </Row>

      <Row
        gutter={16}
        justify={"center"}
        style={{ paddingTop: "2rem" }}
        className={`takaful--content-profile-box1`}
      >
        <Col
          xxl={5}
          xl={5}
          lg={5}
          md={5}
          sm={5}
          xs={24}
          className="takaful--content-profile-col"
        >
          <p className="takaful--content-services-request-p">نص التوكيل :</p>
        </Col>
        <Col
          xxl={19}
          xl={19}
          lg={19}
          md={19}
          sm={19}
          xs={24}
          className="takaful--content-profile-col"
        >
          <p className="takaful--content-services-request-span ">
            {parse(authorization.authorization_description)}
          </p>
        </Col>
      </Row>
      <Row
        justify={"end"}
        dir="rtl"
        style={{ width: "100%", paddingTop: "1rem" }}
      >
        <PrimaryButton onClick={onFinish} title=" أقر بالموافقة على التوكيل " />
      </Row>
    </>
  );
};

export default AddProsecutionRequest;
